import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\totoone-lat\\node_modules\\next\\dist\\client\\app-dir\\link.js");
